(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/react/pages/terms/terms.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/react/pages/terms/terms.js'); 
'use strict';

const {
  Footer,
  MainPage,
  TopMenu
} = svs.termsIntegrity.sharedComponents;
const {
  useGetCmsDataFolder
} = svs.termsIntegrity.sharedComponents;
const {
  DocList
} = svs.termsIntegrity.sharedComponents;
const Terms = () => {
  const termsFolderId = ReactRedux.useSelector(state => state.termsIntegrity.termsFolderId);
  const termsServiceFolderId = ReactRedux.useSelector(state => state.termsIntegrity.termsServiceFolderId);
  const {
    data: doc1Data,
    loading: doc1Loading,
    dataError: doc1DataError
  } = useGetCmsDataFolder(termsFolderId);
  const {
    data: doc2Data,
    loading: doc2Loading,
    dataError: doc2DataError
  } = useGetCmsDataFolder(termsServiceFolderId);
  return React.createElement(React.Fragment, null, React.createElement(TopMenu, null), React.createElement(MainPage, null, React.createElement("h2", null, "Grundl\xE4ggande kundvillkor"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, doc1DataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), doc1Loading && React.createElement("div", null, "Laddar dokument..."), ' ', doc1Data && doc1Data.length > 0 && React.createElement(DocList, {
    docList: doc1Data
  })), React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement("h2", null, "Tj\xE4nstespecifika kundvillkor"), React.createElement("div", {
    className: "margin-xs-top-1"
  }, doc2DataError && React.createElement("div", null, "Fel vid h\xE4mtning av dokument"), doc2Loading && React.createElement("div", null, "Laddar dokument..."), doc2Data && doc2Data.length > 0 && React.createElement(DocList, {
    docList: doc2Data
  })))), React.createElement(Footer, null));
};
svs.termsIntegrity.terms.Terms = Terms;
 })(window);